const DeploymentFooter = () => (
  <footer className="flex flex-wrap justify-between gap-2.5 border-t border-border pt-[26px] pb-10 text-[15px] text-muted-foreground">
    <span>Somatiq AI Labs Private Limited, Bengaluru. Every second matters. Every detail counts.</span>
    <a href="mailto:info@somatiq.ai" className="underline">info@somatiq.ai</a>
  </footer>
);

export default DeploymentFooter;
